import React, { useEffect, useState } from 'react';
import { Badge } from './ui/badge';
import { getTitlePixelLength, getMetaPixelLength, TITLE_PIXEL_LIMITS, META_PIXEL_LIMITS } from '../utils/pixelLength';

export default function CharacterCount({ count, limit, type = 'default', showInfinite = true, text = '' }) {
  const [pixelLength, setPixelLength] = useState(0);

  useEffect(() => {
    if (type === 'title' || type === 'meta') {
      const pixelWidth = type === 'title' 
        ? getTitlePixelLength(text)
        : getMetaPixelLength(text);
      setPixelLength(Math.round(pixelWidth));
    }
  }, [text, type]);

  const getVariant = () => {
    // No limit set
    if (!limit) return 'purple';

    // Featured snippet special case
    if (type === 'featured-snippet') {
      if (count === 0) return 'purple';
      if (count <= 199) return 'warning';
      if (count <= 300) return 'positive';
      return 'negative';
    }

    // Title pixel length case
    if (type === 'title' && text) {
      if (pixelLength < TITLE_PIXEL_LIMITS.min) return 'warning';
      if (pixelLength > TITLE_PIXEL_LIMITS.max) return 'negative';
      return 'positive';
    }

    // Meta description pixel length case
    if (type === 'meta' && text) {
      if (pixelLength > META_PIXEL_LIMITS.max) return 'negative';
      return 'positive';
    }

    // Default behavior
    if (count === 0) return 'purple';
    if (count <= limit) return 'positive';
    return 'negative';
  };

  const getLabel = () => {
    if (type === 'word') return 'Words';
    return 'Characters';
  };

  const getPixelDisplay = () => {
    if (!text || (type !== 'title' && type !== 'meta')) return '';
    return ` (${pixelLength}px)`;
  };

  return (
    <Badge variant={getVariant()}>
      {getLabel()}: {count} {limit ? `/ ${limit}` : showInfinite ? '/ ∞' : ''}{getPixelDisplay()}
    </Badge>
  );
} 